import * as angular from 'angular'
import './geofocus.scss';
import { Component, Input } from 'ng-metadata/core';

/**
 * @name mwMediaSourceDocumentGeofocus
 * @module mw.components.contentDocuments
 *
 * @param {string} [text] - text to be displayed inside component.
 *
 * @description
 * `<mw-media-source-document-geofocus>` is a component used to display the job title.
 *
 * @usage
 * <hljs hljs-language="html">
 * </hljs>
 */
@Component({
    selector: 'mw-media-source-document-geofocus',
    template: `
        <span
            class="mw-media-source-document-geofocus"
            ng-bind-html="::$ctrl.text">
        </span>
    `,
})
export class MediaSourceDocumentGeofocusComponent {
    @Input('<') text: string;
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-source-document/geofocus/geofocus.component.ts